import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { navigateToDetail } from '../../coaching-detail/navigate';
import { TranslationKeyMap } from '../coaching-observation.i18n';
import {
    AllowedActions,
    EnabledActions,
} from '../observation/observation.model';

import { ObservationControllerMode } from './controller.observation.model';

@Component({
    selector: '[cmpsObservationController]',
    templateUrl: './controller.observation.component.html',
})
export class ObservationControllerComponent implements OnDestroy {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _ObservationControllerMode = ObservationControllerMode;

    @Input() mode: ObservationControllerMode;
    @Input() published: boolean;
    @Input() allowedActions: AllowedActions;
    @Input() enabledActions: EnabledActions;
    @Input() pending: boolean;
    @Input() dirty: boolean;
    @Output() cancel: EventEmitter<void>;
    @Output() share: EventEmitter<void>;
    @Output() edit: EventEmitter<void>;
    @Output() delete: EventEmitter<void>;
    @Output() publish: EventEmitter<void>;
    @Output() save: EventEmitter<void>;

    constructor(
        private readonly _router: Router,
        private readonly _activatedRoute: ActivatedRoute,
    ) {
        this.mode = ObservationControllerMode.DEFAULT;

        this.cancel = new EventEmitter();
        this.share = new EventEmitter();
        this.edit = new EventEmitter();
        this.delete = new EventEmitter();
        this.publish = new EventEmitter();
        this.save = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.cancel.complete();
        this.share.complete();
        this.edit.complete();
        this.delete.complete();
        this.publish.complete();
        this.save.complete();
    }

    /** @private */ _onCloseToDetailClick(): void {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        navigateToDetail(this._router, this._activatedRoute, false);
    }
}
